import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router";
import { FaPlus } from "react-icons/fa";
import PageHeaderV2 from "../../../pageheaderV2/PageHeaderV2";
import { CurrentUserContext } from "../../../../App";
import Select from "../../../material/select/SelectV2";
import InputV2 from "../../../material/input/InputV2";
import * as adminApi from "../../../../service/adminApi";
import { RedirectCode400 } from "../../../RedirectCode400";

function AddContact() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [titlepage, setTitlePage] = useState("");
  const [inputs, setInputs] = useState([
    {
      prefix: location.state?.prefix ?? "",
      firstName: location.state?.firstName ?? "",
      lastName: location.state?.lastName ?? "",
      phone: location.state?.phone ?? "",
      email: location.state?.email ?? "",
      department: location.state?.department ?? "",
    },
  ]);

  const addInput = () => {
    setInputs([
      ...inputs,
      {
        prefix: "",
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        department: "",
      },
    ]);
  };

  const deleteInput = (index) => {
    const updatedInputs = inputs.filter((_, i) => i !== index);
    setInputs(updatedInputs);
  };

  const handleChange = (index, field, value) => {
    const updatedInputs = inputs.map((input, i) =>
      i === index ? { ...input, [field]: value } : input,
    );
    setInputs(updatedInputs);
  };

  useEffect(() => {
    if (location.state?.type === "contact") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      setTitlePage("เพิ่มข้อมูลการติดต่อ");
    } else {
      navigate("/");
    }
  }, []);

  const addContact = async () => {
    setLoading(true);
    let res = await adminApi.addContact(inputs);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/admin/management/contact");
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const updateContact = async () => {
    setLoading(true);
    let res = await adminApi.updateContact(location.state?.id, inputs);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/admin/management/contact");
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        // console.log(res["data"]["message_th"] || res["data"]["message"]);
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const onSubmit = () => {
    const isValid = inputs.every((input) => {
      if (!input.prefix) {
        setIsMessage({ type: "warning", data: "กรุณาเลือกคำนำหน้า!" });
        return false;
      }

      if (!input.firstName) {
        setIsMessage({ type: "warning", data: "กรุณากรอกชื่อ!" });
        return false;
      }

      if (!input.lastName) {
        setIsMessage({ type: "warning", data: "กรุณากรอกนามสกุล!" });
        return false;
      }

      if (!input.phone) {
        setIsMessage({ type: "warning", data: "กรุณากรอกเบอร์โทร!" });
        return false;
      }

      if (!input.email) {
        setIsMessage({ type: "warning", data: "กรุณากรอก Email!" });
        return false;
      }

      if (!input.department) {
        setIsMessage({ type: "warning", data: "กรุณากรอกหน่วยงาน" });
        return false;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(input.email)) {
        setIsMessage({
          type: "warning",
          data: `อีเมล "${input.email}" ไม่ถูกต้อง!`,
        });
        return false;
      }

      return true;
    });

    if (!isValid) {
      return;
    }

    if (location.state?.type === "contact") {
      location.state?.id ? updateContact() : addContact();
    }
  };

  const prefix = [
    { name: "นาย", value: "นาย" },
    { name: "นาง", value: "นาง" },
    { name: "นางสาว", value: "นางสาว" },
  ];

  return (
    <div>
      <PageHeaderV2 titlename={titlepage ?? ""} />
      <div className="flex flex-col justify-center items-start w-full gap-[20px]">
        <div className="rounded-[6px] border-[#E2E2E4] border w-[100%] min-w-[400px] p-[17px_16px]">
          {inputs.map((input, index) => (
            <div key={index}>
              <div className="bg-[#ECF7F3] rounded-[5px] p-[17px_18px] mb-[10px]">
                <div className="flex justify-between items-center mb-[10px]">
                  ข้อมูลส่วนตัว
                  {location.state?.prefix ? (
                    <></>
                  ) : (
                    <button onClick={() => deleteInput(index)}>x</button>
                  )}
                </div>
                <div className="flex flex-row gap-[16px] md:flex-col w-full mb-[10px]">
                  <div className="flex flex-col text-[16px] font-['Prompt'] w-[350px] md:w-full">
                    คำนำหน้า
                    <Select
                      lable="คำนำหน้า"
                      value={input.prefix}
                      setValue={(value) => handleChange(index, "prefix", value)}
                      list={prefix}
                      placeholder="คำนำหน้า"
                      className="text-[16px] font-['Prompt']"
                    />
                  </div>
                  <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
                    ชื่อ
                    <InputV2
                      type="text"
                      placeholder="กรอกชื่อ"
                      value={input.firstName}
                      onChangeEvt={(value) =>
                        handleChange(index, "firstName", value)
                      }
                    />
                  </div>
                  <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
                    นามสกุล
                    <InputV2
                      type="text"
                      placeholder="กรอกนามสกุล"
                      value={input.lastName}
                      onChangeEvt={(value) =>
                        handleChange(index, "lastName", value)
                      }
                    />
                  </div>
                </div>
                <div className="flex flex-row gap-[16px] md:flex-col w-full mb-[10px]">
                  <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
                    เบอร์โทร
                    <InputV2
                      type="number"
                      placeholder="กรอกเบอร์โทร"
                      value={input.phone}
                      onChangeEvt={(value) =>
                        handleChange(index, "phone", value)
                      }
                    />
                  </div>
                  <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
                    Email
                    <InputV2
                      type="email"
                      placeholder="กรอกอีเมล"
                      value={input.email}
                      onChangeEvt={(value) =>
                        handleChange(index, "email", value)
                      }
                    />
                  </div>
                </div>
                <div className="flex flex-col text-[16px] font-['Prompt'] mb-[10px]">
                  หน่วยงาน
                  <InputV2
                    type="text"
                    placeholder="กรอกหน่วยงาน"
                    value={input.department}
                    onChangeEvt={(value) =>
                      handleChange(index, "department", value)
                    }
                  />
                </div>
              </div>
            </div>
          ))}

          {location.state?.prefix ? (
            <div className="w-full hidden flex-row justify-end items-center">
              <button
                onClick={addInput}
                className="flex flex-row justify-center items-center w-[192px] h-[40px] bg-[#70B9F0] text-[#FFFFFF] rounded-[4px] mt-[10px]"
              >
                <FaPlus />
                เพิ่มข้อมูลการติดต่อ
              </button>
            </div>
          ) : (
            <div className="w-full flex flex-row justify-end items-center">
              <button
                onClick={addInput}
                className="flex flex-row justify-center items-center w-[192px] h-[40px] bg-[#70B9F0] text-[#FFFFFF] rounded-[4px] mt-[10px]"
              >
                <FaPlus />
                เพิ่มข้อมูลการติดต่อ
              </button>
            </div>
          )}
        </div>
        <div className="flex flex-row gap-3 justify-end items-center mt-[10px] w-full">
          <button
            onClick={() => navigate("/admin/management/faq")}
            className="button-theme-pg w-[90px] h-[40px] bg-[#C0C0C0] rounded-[5px] text-[#FFFFFF] flex justify-center items-center"
          >
            ยกเลิก
          </button>
          <button
            onClick={onSubmit}
            className="button-theme-pg w-[90px] h-[40px] bg-[#2EA669] rounded-[5px] text-[#FFFFFF] flex justify-center items-center"
          >
            บันทึก
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddContact;
